export default __webpack_public_path__ + "static/media/icon-location.325ff3d9.svg";